import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {
    AddressFormatter, ComponentFormatter,
    CurrencyFormatter, DateFormatter,
    EmailFormatter,
    remoteComponentFormatter, remoteOptionFormatter,
    TelnumFormatter
} from "../../../utils/formatters";
import {componentFilter, optionFilter} from "../../../utils/filters";
import Select from "../../form/Select";
import {formatView} from "../../../utils/components";
import {array_dots} from "../../../utils/array";
import Tooltip from "../../../utils/Tooltip";

class shippingList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading, pageSize, onLoadCompleted} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: pageSize || 5, formId: this.props.formId, onLoadCompleted};
        if (Array.isArray(props.view)) {
            props.view.push("client_component_type");
        } else if(!!props.view && typeof props.view !== "string") {
            props.view.client_component_type = "";
        } else if (typeof props.view !== "string") {
            props.view = ["client_component_type", "id"];
        }
        const columns = {
            "tracking_id": {
                header: 'Követési kód',
                width: 1,
                sortable,
                filterable
            },
            ...(
                this.props.pos === undefined
                    ?
                    {
                        "pickupaddress": {
                            header: 'Honnan',
                            width: 1,
                            renderer: AddressFormatter
                        },
                        "shippingaddress": {
                            header: 'Hova',
                            width: 1,
                            renderer: AddressFormatter
                        }
                    }
                    :
                    {
                        "pid": {
                            header: 'Azonosító',
                            width: 1,
                            sortable,
                            filterable
                        },
                    }
            ),
            "agent_name": {
                header: 'Megrendelő',
                width: 1,
                sortable,
                filterable
            },
            "contact": {
                header: 'Kapcsolattartó',
                width: 1,
                sortable,
                filterable
            },
            "telnum": {
                header: 'Telefonszám',
                width: 1,
                sortable,
                filterable,
                renderer: TelnumFormatter
            },
            "email": {
                header: 'Email',
                width: 1,
                sortable,
                filterable,
                renderer: EmailFormatter
            },
            "request": {
                header: 'Megjegyzés',
                width: 1,
                sortable,
                filterable,
                renderer: (value) => <Tooltip title={value}><div className="nowrap ellipsis" style={{maxWidth: "10vw"}}>{value}</div></Tooltip>
            },
            ...(this.props.pos === undefined || this.props.failedActions ? {
                "serviceprovider_type": {
                    header: this.props.failedActions ? ' ' : 'Szállító',
                    width: 1,
                    sortable: !this.props.failedActions,
                    filterable: this.props.failedActions ? false : componentFilter({component: "ShippingServiceProvider", labelfield: "methodname"}),
                    renderer: this.props.failedActions ? ((value, row) => row.state + "" !== "2" ? <Select
                        optionname={"personalpickup_failed_" + row.client_component_type}
                        objectValue={false}
                        storeType="local"
                        value={(this.props.failedSelection || {})[row.id]}
                        label={false}
                        placeholder="Művelet"
                        isClearable={true}
                        saveChanges={(field, value) => {
                            const values = {...(this.props.failedSelection || {})};
                            if (value) {
                                values[row.id] = value;
                            } else {
                                delete values[row.id];
                            }
                            this.props.failedActions(values);
                        }}
                    /> : <div className="nowrap">{remoteComponentFormatter({component: "ShippingServiceProvider", labelfield: "methodname"})(value)}</div>) : (value) => <div className="nowrap">{remoteComponentFormatter({component: "ShippingServiceProvider", labelfield: "methodname"})(value)}</div>
                },
            } : {}),
            ...(!this.props.failedActions ? {
                "state": {
                    header: 'Státusz',
                    width: 1,
                    sortable,
                    operator: "=",
                    filterable: optionFilter("shippingstate"),
                    renderer: remoteOptionFormatter("shippingstate")
                },
                "status": {
                    header: 'Státusz',
                    width: 1,
                    sortable,
                    operator: "=",
                    //filterable: optionFilter("FurgeFutarStatus"),
                    renderer: (value, row) => remoteOptionFormatter(row.serviceprovider_type + "Status")(value)
                },
                "shipping_fee": {
                    header: 'Szállítási díj',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: CurrencyFormatter,
                    className: "currency"
                },
                "cod_amount": {
                    header: 'Utánvét összege',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: CurrencyFormatter,
                    className: "currency"
                },
                "expires_at": {
                    header: 'Lejárat',
                    width: 1,
                    className: "nowrap",
                    sortable,
                    filterable,
                },
            } : {}),
            ...(
                this.props.pos !== undefined
                    ?
                    {
                        "client_component_type": {
                            header: 'Típus',
                            width: 1,
                            renderer: (value) => ComponentFormatter({component: value, base: 'shipping_client_component_type'})
                        },
                    }
                    :
                    {}
            ),
        };
        props.view = Object.keys(array_dots(formatView(props.view, Object.keys(columns))));
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "shippingList"}
                {...props}
                columns={columns}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm && this.props.loadForm(selection.value)}
            />
        );
    }
}

export default shippingList;
